/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * 
 * @export
 * @interface GuaranteeDtoDeductible
 */
export interface GuaranteeDtoDeductible {
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDtoDeductible
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDtoDeductible
     */
    idVariableValue: string;
    /**
     * 
     * @type {ConfigurableParameterDto}
     * @memberof GuaranteeDtoDeductible
     */
    parameters: ConfigurableParameterDto;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeDtoDeductible
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDtoDeductible
     */
    warningMessage?: string;
}

/**
 * Check if a given object implements the GuaranteeDtoDeductible interface.
 */
export function instanceOfGuaranteeDtoDeductible(value: object): value is GuaranteeDtoDeductible {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('idVariableValue' in value) || value['idVariableValue'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GuaranteeDtoDeductibleFromJSON(json: any): GuaranteeDtoDeductible {
    return GuaranteeDtoDeductibleFromJSONTyped(json, false);
}

export function GuaranteeDtoDeductibleFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeDtoDeductible {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idVariableValue': json['idVariableValue'],
        'parameters': ConfigurableParameterDtoFromJSON(json['parameters']),
        'value': json['value'],
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
    };
}

export function GuaranteeDtoDeductibleToJSON(json: any): GuaranteeDtoDeductible {
    return GuaranteeDtoDeductibleToJSONTyped(json, false);
}

export function GuaranteeDtoDeductibleToJSONTyped(value?: GuaranteeDtoDeductible | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idVariableValue': value['idVariableValue'],
        'parameters': ConfigurableParameterDtoToJSON(value['parameters']),
        'value': value['value'],
        'warningMessage': value['warningMessage'],
    };
}

